import React from "react";
import { Grid, Typography, Skeleton, Box } from "@mui/material";
import BorderedLayout from "../../../layouts/BorderedLayout";
import CollapseComponent from "../../../components/collapse/collapseComponent";

const collapseData = [
  { id: 0, title: "مشخصات تسهیلات" },
  { id: 1, title: "فروش" },
  { id: 2, title: "اطلاعـات کیف‌ها" },
];

const CustomerInfoDetailSkeleton = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <div>
        <BorderedLayout
          title={
            <Typography
              sx={{
                color: "#1D4A87",
                fontSize: "1.1rem",
                fontWeight: "bold",
              }}
            >
              مشخصات متقاضی
            </Typography>
          }
          backgroundColor="#F9FAFC"
        >
          <Grid container sx={{ padding: "20px" }} gap={"20px"}>
            {/* top section */}
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    نام و نام خانوادگی: <Skeleton variant="text" width={100} />
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    کد ملی: <Skeleton variant="text" width={100} />
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    شماره شناسنامه: <Skeleton variant="text" width={100} />
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    تاریخ تولد: <Skeleton variant="text" width={100} />
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* middle section  */}
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    نام پدر: <Skeleton variant="text" width={100} />
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    سری/سریال شناسنامه: <Skeleton variant="text" width={100} />
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    شماره همراه: <Skeleton variant="text" width={100} />
                  </Typography>
                </Grid>
                <Grid item xs={3}></Grid>
              </Grid>
            </Grid>
            {/* description section */}
            <Grid
              item
              xs={12}
              sx={{
                borderTop: "1px solid #C1C7CB",
                paddingTop: "20px",
                display: "flex",
                flexDirection: "column",
                gap: "15px",
              }}
            >
              <Typography
                sx={{
                  color: "#1D4A87",
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                }}
              >
                مشخصات سکونتی
              </Typography>
              <Skeleton variant="text" width={200} />
              <Skeleton variant="text" width={200} />
            </Grid>
          </Grid>
        </BorderedLayout>
      </div>

      <div>
        {collapseData.map((item) => (
          <CollapseComponent title={item.title} key={item.id}>
            <Grid container gap={"15px"} flexDirection={"column"}>
              <Grid
                container
                sx={{ justifyContent: "start", alignItems: "center" }}
                spacing={2}
                columns={14}
              >
                <Grid
                  item
                  xs={14}
                  sm={4}
                  md={4}
                  lg={3}
                  xl={2}
                  width={"100%"}
                  height={"100%"}
                >
                  <Box
                    sx={{
                      width: "120px",
                      height: "120px",
                      border: "1px solid #EDEFEF",
                      borderRadius: "5px",
                      boxShadow: "0px 2px 4px rgba(0,0,0,0.16)",
                    }}
                  >
                    <Skeleton variant="rectangular" width={120} height={120} />
                  </Box>
                </Grid>
                <Grid item xs={14} sm={10} md={10} lg={11} xl={12}>
                  <Grid
                    container
                    flexDirection={"column"}
                    gap={"15px"}
                    justifyContent={"center"}
                    alignItems={"start"}
                    width={"100%"}
                  >
                    <Grid
                      item
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "1.1rem",
                          color: "#1D4A87",
                          display: "flex",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        <Skeleton variant="text" width={100} />
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: ".9rem",
                          color: "#1D4A87",
                          cursor: "pointer",
                        }}
                      >
                        <Skeleton variant="text" width={100} />
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.9rem",
                          width: "20%",
                          color: "#1D4A87",
                        }}
                      >
                        <Skeleton variant="text" width={100} />
                      </Typography>
                      <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
                        <Skeleton variant="text" width={100} />
                      </Typography>
                      <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
                        <Skeleton variant="text" width={100} />
                      </Typography>
                      <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
                        <Skeleton variant="text" width={100} />
                      </Typography>
                      <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
                        <Skeleton variant="text" width={100} />
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CollapseComponent>
        ))}
      </div>
    </Box>
  );
};

export default CustomerInfoDetailSkeleton;
